import { Endpoint, RecordsForPage } from "../mb_constants";

/**
 * 
 * @param {*} page 
 * @param {*} search 
 * @returns 
 */
const MbApi_VatList = async (page, search, getAll = null) => {
    
    try{
        const response = await fetch(
            `${Endpoint}/api/mb/v1/vat/list?page=${page}&record_for_page=${!getAll ? RecordsForPage : "9999"}${search ? `&search=${search}` : ''}`,
            {
                headers: {
                    'jwt': `Bearer ${localStorage.getItem('jwt')}`
                }
            }
        );

        if(response.status == 200){
            const data = await response.json();
            return data;
        }
    }catch(_){
        
    }

    return null;
};

/**
 * 
 * @param {*} body 
 * @returns 
 */
const MbApi_VatCreate = async (body) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/vat/create`,
        {
            method: "POST",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            },
            body: body
        }
    );

    try{
        if(response.status == 201){
            const res = await response.json();
            if(res.Result == "OK"){
                return res.Json;
            }
        }
    }catch(_){

    }

    return false;
};

/**
 * 
 * @param {*} id_vat 
 * @returns 
 */
const MbApi_VatDelete = async (id_vat) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/vat/delete?id_vat=${id_vat}`,
        {
            method: "DELETE",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            }
        }
    );

    try{
        if(response.status == 200){
            const res = await response.json();
            if(res.Result == "OK"){
                return true;
            }
        }
    }catch(_){

    }

    return false;

};

export {
    MbApi_VatList,
    MbApi_VatCreate,
    MbApi_VatDelete
}